<template>
  <cube-divider :position="position" text="文本内容" />
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    properties: {
      position: String
    }
  })
</script>

<script type="application/json">
  {
    "usingComponents": {
      "cube-divider": "@mpxjs/mpx-cube-ui/src/components/divider/index"
    }
  }
</script>